// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"121d9a64","526":"92e1de7b","707":"47e42133","918":"f44cc997"}[chunkId] + ".css";
};